import { CloseButton, SaveButton } from '@ui/shared/Button';
import * as React from 'react';

import styled from 'styled-components';
import { testTypesProvider } from '../../../data/providers/testTypesProvider';
import { ISelectableTestType, ITestType } from '../../../data/types';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import { ControlLabel } from '../../shared/form/ControlLabel';
import { ControlSpacer } from '../../shared/form/ControlSpacer';
import { TestTypeSelect } from '../../shared/form/selects/TestTypeSelect';
import { LinearLoading } from '../../shared/loading/LinearLoading';
import { PopupCard, PopupCardContent } from '../../shared/popups/PopupCard';
import { ActiveMetrics } from './ActiveMetrics';
import { ImperialSetting } from './ImperialSetting';
import { KeyMetric } from './KeyMetric';

interface IProps {
  onClose: () => void;
}
export const MetricSettings = (props: IProps): React.ReactElement => {
  const [activeTestType, setActiveTestType] =
    React.useState<ISelectableTestType>(null);
  const [testTypes, setTestTypes] = React.useState<ITestType[]>([]);
  const [testTypesLoading, setTestTypesLoading] = React.useState<boolean>(true);

  /**
   * @description handle test type change
   * @param value
   */
  const onTestTypeChange = (value: ISelectableTestType): void =>
    setActiveTestType(value);

  /**
   * @description subscribe to test types
   */
  React.useEffect((): (() => void) => {
    const testTypeSubscriber = testTypesProvider().subscribe(
      (mTestTypes: ITestType[]): void => {
        setTestTypes(mTestTypes);
        setTestTypesLoading(false);
      }
    );
    return (): void => {
      return testTypeSubscriber.unsubscribe();
    };
  }, []);

  return (
    <PopupCard
      aria-label='Metric Settings Popup'
      size='large'
      onClose={props.onClose}
      noClickOutside
    >
      <PopupCardContent role=''>
        <CardHeader surface={8} style={{ flex: 0 }}>
          <CardHeaderLeft>
            <h5>Metric Settings</h5>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody style={{ flex: 1 }} notScrollable>
          {testTypesLoading && <LinearLoading />}
          <TopControlsContainer>
            <ImperialSetting />
            <ControlSpacer />
            <ControlLabel>Test Type</ControlLabel>
            <TestTypeSelect
              value={activeTestType}
              onChange={onTestTypeChange}
              disabled={false}
            />
            <ControlSpacer />
            <KeyMetric activeTestType={activeTestType} />
          </TopControlsContainer>
          <ActiveMetricsContainer>
            <ActiveMetrics
              testType={activeTestType ? activeTestType.entity : null}
              testTypes={testTypes}
            />
          </ActiveMetricsContainer>
        </CardBody>
        <CardFooter surface={8} style={{ flex: 0 }}>
          <CardFooterLeft />
          <CardFooterRight>
            <SaveButton onClick={props.onClose} />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </PopupCard>
  );
};

const TopControlsContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  max-width: 400px;
`;

const ActiveMetricsContainer = styled.div`
  padding: 0 20px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
